<template>
  <Modal
      v-model="_value"
      width="500"
      title="部标1078视频指令"
      @on-visible-change="visibleChange"
      ok-text="关闭"
      cancel-text="">
    <Form ref="reqRealtimeAvTrans" autoComplete="on" v-model="reqRealtimeAvTrans"
          class="card-box login-form">
      <FormItem prop="ip">
        <label style="display: inline-block; width: 100px;">视频数据IP</label>
        <Input style="display: inline-block; width: 300px;" v-model="reqRealtimeAvTrans.ip"
               placeholder="请输入视频数据IP">
        </Input>
      </FormItem>
      <FormItem prop="channel">
        <label style="display: inline-block; width: 100px;">逻辑通道号</label>
        <InputNumber style="display: inline-block; width: 300px;" v-model="reqRealtimeAvTrans.channel"
                     placeholder="请输入逻辑通道号">
        </InputNumber>
      </FormItem>
      <FormItem prop="tcpPort">
        <label style="display: inline-block; width: 100px;">TCP端口</label>
        <InputNumber style="display: inline-block; width: 300px;" v-model="reqRealtimeAvTrans.tcpPort"
                     placeholder="请输入TCP端口">
        </InputNumber>
      </FormItem>
      <FormItem prop="udpPort">
        <label style="display: inline-block; width: 100px;">UDP端口</label>
        <InputNumber style="display: inline-block; width: 300px;" v-model="reqRealtimeAvTrans.udpPort"
                     placeholder="请输入UDP端口">
        </InputNumber>
      </FormItem>
      <FormItem prop="code">
        <label style="display: inline-block; width: 100px;">码流类型</label>
        <Select v-model="code">
          <Option value=0 key=0>主码流</Option>
          <Option value=1 key=1>子码流</Option>
        </Select>
      </FormItem>
      <FormItem prop="dataType">
        <label style="display: inline-block; width: 100px;">数据类型</label>
        <Select v-model="dataType">
          <Option value=0 key=0>音视频</Option>
          <Option value=1 key=1>视频</Option>
          <Option value=2 key=2>双向通话</Option>
          <Option value=3 key=3>监听</Option>
          <Option value=4 key=4>广播</Option>
          <Option value=5 key=5>透传</Option>
        </Select>
      </FormItem>
      <Button type="primary" @click="onClean" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSend">发送</Button>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'jt1078cmdmodal',
    components: {},
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        reqRealtimeAvTrans: {
          id: 0,
          ip: '122.13.4.227',
          channel: 1,
          tcpPort: 31048,
          udpPort: 0,
          code: 0,
          dataType: 0
        },
        code: '0',
        dataType: '0'
      }
    },
    methods: {
      ...mapActions([]),
      visibleChange(val) {
        if (val) {
          this.reqRealtimeAvTrans.id = this._initValue
        }
      },
      onClean() {
        this.reqRealtimeAvTrans.ip = ''
        this.reqRealtimeAvTrans.channel = 0
        this.reqRealtimeAvTrans.tcpPort = 0
        this.reqRealtimeAvTrans.udpPort = 0
        this.reqRealtimeAvTrans.code = 0
        this.reqRealtimeAvTrans.dataType = 0
        this.code = '0'
        this.dataType = '0'
      },
      onSend() {

        this.reqRealtimeAvTrans.code = parseInt(this.code, 10)
        this.reqRealtimeAvTrans.dataType = parseInt(this.dataType, 10)

        console.log(this.reqRealtimeAvTrans)

        store.dispatch('NetCommandServ_Jt1078ReqRealtimeAVTrans',
          {params: this.reqRealtimeAvTrans}
        ).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        });
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
